document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const walletButton = document.querySelector('shop-pay-wallet-button');

    if (walletButton) {
      walletButton.addEventListener('click', function (event) {
        event.preventDefault(); // Prevent instant redirect (temporarily)
        
        // Grab values
        const currency = walletButton.getAttribute('buyer-currency') || 'USD';
        let walletParams = walletButton.getAttribute('wallet-params');
        let shopId = null;

        try {
          walletParams = JSON.parse(walletParams.replace(/&quot;/g, '"'));
          shopId = walletParams.shopId;
        } catch (e) {
          console.warn('wallet-params parsing failed:', e);
        }

        // Fire the FB event
        fbq('track', 'AddToCart', {
          value: 0, // Replace with actual price if available
          currency: currency,
          content_ids: [shopId],
          content_type: 'product'
        });

        // Wait a little before allowing redirect (delay ~200ms is often enough)
        setTimeout(() => {
          walletButton.click(); // Let it do its normal thing after fbq fires
        }, 200); // Adjust this delay if needed
      }, { once: true }); // Ensure it runs only once
    } else {
      console.warn('<shop-pay-wallet-button> not found on the page.');
    }
  }, 1000); // Run after 1 second delay from DOM ready
});
